
import { get, post } from './index'

//App登录
export const customerLogin = (data) => post('/flows/api/customerLogin', data)

//发送验证码
export const sendCode = (data) => get('/flows/api/sendCode', data);

//获取待办数
export const selectAgendaNum = () => get('/flows/customerAgenda/selectAgendaNum');

//获取认证信息
export const selectUserAuth = () => get('/flows/customer/selectUserAuth');

// 查询消息列表
export const getMessageList = (data) => post('/flows/message/getMessageList', data)

//查询消息详情
export const getMessage = (messageId) => get(`/flows/message/getMessage/${messageId}`);

//读消息
export const readMessage = (messageId) => get(`/flows/message/readMessage/${messageId}`);

//查询Web端个人信息
export const selectWebCustomerInfo = () => get(`/flows/web/customer/selectWebCustomerInfo`);

//修改用户信息
export const updateWebCustomerInfo = (data) => post('/flows/web/customer/updateWebCustomerInfo', data)

//货主端首页数据
export const selectForwarderHomePageData = (data) => post('/flows/web/homepage/selectForwarderHomePageData', data)

//数据统计
export const dataStatistics = () => get(`/flows/forwarder/dataStatistics`);

//查询资产
export const selectAccount = () => get(`/flows/account/selectAccount`);

//查询农行钱包
export const selectabcAccount = () => get(`/flows/account/selectAccount`);

//查询充值明细
export const selectPayList = () => get(`/flows/app/pay/selectPayList`);

//查询提现明细
export const selectTransferList = () => get(`/flows/app/pay/selectTransferList`);

//查询用户消费记录
export const selectConsumption = () => get(`/flows/account/selectConsumption`);

//查询用户收入记录
export const selectIncome = () => get(`/flows/account/selectIncome`);

//查询退款记录
export const selectRefund = () => get(`/flows/account/selectRefund`);

// 获取提现限额说明
export const selectTransferDictList = () => get(`/flows/app/pay/selectTransferDictList`);

//查询是否设置支付密码
export const selectHasPayPassword = () => post('/flows/customer/payPassword/selectHasPayPassword')

//支付宝申请提现
export const applyForTransfer = (data) => post('/flows/app/pay/applyForTransfer', data)

//获取充值字典表
export const selectTopUpList = (type) => get(`/flows/app/pay/selectTopUpList/${type}`);




//上传法人身份证-1.0.2
export const uploadCompanyIdentity = (data) => post('/flows/companyCertification/uploadIdentity', data, { 'Content-Type': 'multipart/form-data' });


//获取用户合同列表
export const customerContractList = (data) => post('/flows/customer/contact/customerContractList', data)

//查询用户合同详情
export const customerContractInfo = (contractId) => get(`/flows/customer/contact/customerContractInfo/${contractId}`);

//查询钱包
export const selectCompanyAccount = () => get(`/flows/companyAccount/selectCompanyAccount`);

//企业钱包 查询充值明细
export const selectCompanyPayList = (companyAccountId) => get(`/flows/companyAccount/selectCompanyPayList/${companyAccountId}`);

//查询充值记录
export const selectPayRecord = (data) => post(`/flows/account/selectPayRecord`, data);

//企业钱包 查询提现明细
export const selectCompanyWithdrawList = (companyAccountId) => get(`/flows/companyAccount/selectCompanyWithdrawList/${companyAccountId}`);

//企业钱包 查询消费/退款记录 类型 0->消费 1->退款 2->收入
export const selectCompanyConsumptionList = (data) => post(`/flows/companyAccount/selectCompanyConsumptionList`, data);

//企业钱包  实名认证图片上传
export const uploadCompanyAccountPic = (data) => post('/flows/companyAccount/uploadCompanyAccountPic', data, { 'Content-Type': 'multipart/form-data' });

//企业钱包认证
export const companyAccountCertification = (data) => post(`/flows/companyAccount/companyAccountCertification`, data);

//web充值下单
export const webCreatePay = (data) => post(`/flows/app/pay/webCreatePay`, data);

//企业钱包 提现申请
export const withdrawDeposit = (data) => post(`/flows/companyAccount/withdrawDeposit`, data);

//查询对公银行账户字典
export const selectBankDictList = () => get(`/flows/companyAccount/selectBankDictList`);

//查询收到的评价
export const selectReceiveEvaluationList = (data) => post(`/flows/evaluation/selectReceiveEvaluationList`, data);

//查询发表的评价
export const selectPublishEvaluationList = (data) => post(`/flows/evaluation/selectPublishEvaluationList`, data);

//查询订单列表
export const selectOrderList = (data) => post(`/flows/forwarder/selectOrderList`, data);

// 修改支付密码
export const updatePayPassword = (data) => post(`/flows/customer/payPassword/updatePayPassword`, data);

//判断支付密码是否正确
export const checkPayPassword = (data) => post(`/flows/customer/payPassword/checkPayPassword`, data);

//验证身份
export const checkIdentity = (data) => post(`/flows/customer/payPassword/checkIdentity`, data);

// 忘记密码修改密码
export const updateForgetPayPassword = (data) => post(`/flows/customer/payPassword/updateForgetPayPassword`, data);

//发送忘记支付密码手机验证码
export const sendForgetPayPasswordCode = (phone) => get(`/flows/customer/payPassword/sendForgetPayPasswordCode/${phone}`);

//新增发货需求
export const saveDemand = (data) => post(`/flows/forwarder/saveDemand`, data);

//查询货物类型
export const selectGoodsByGoodsName = (data) => get(`/flows/forwarder/selectGoodsByGoodsName`, data, { loading: false });

//获取货主剩余发货次数
export const selectForwarderShipmentsNum = () => get(`/flows/forwarder/selectForwarderShipmentsNum`);


//删除发货需求
export const deleteDemand = (demandId) => get(`/flows/forwarder/deleteDemand/${demandId}`);

//发货需求加价
export const demandRaisePrice = (data) => post(`/flows/forwarder/demandRaisePrice`, data);

//查找司机
export const selectDriverAccount = (account) => get(`/flows/forwarder/selectDriver/${account}`, {}, { loading: false });

//委托运输
export const entrustTransport = (data) => post(`/flows/forwarder/entrustTransport`, data);

//根据发货需求ID查询发货需求信息
export const selectDemandById = (demandId) => get(`/flows/forwarder/selectDemandById/${demandId}`);


//设置常发货源
export const saveFrequent = (data) => post(`/flows/forwarder/saveFrequent`, data);

//查询常发货源
export const selectDemandFrequentList = (data) => post(`/flows/forwarder/selectDemandFrequentList`, data);

//大批量发货
export const batchSendDemand = (data) => post(`/flows/forwarder/batchSendDemand`, data);

//修改大批量发货
export const updateSendDemand = (data) => post(`/flows/forwarder/updateSendDemand`, data);

// 查询是否有司机已卸货订单
export const selectDriverUnloadingOrder = () => get(`/flows/forwarder/selectDriverUnloadingOrder`);

//货主取消申请-1.0.3
export const cancelForCancelOrder = (orderId) => post(`/flows/forwarder/cancelForCancelOrder/${orderId}`)

//货主同意/拒绝取消订单-1.0.3
export const consentCancelOrder = (params) => post(`/flows/forwarder/consentCancelOrder`, params)

//货主支付-1.0.2
export const forwarderPay = (data) => post(`/flows/forwarder/forwarderPay`, data)

//货主确认支付-1.0.2
export const forwarderConfirmPay = (data) => post(`/flows/forwarder/forwarderConfirmPay`, data)

//查询评价字典
export const selectEvaluationByType = () => get(`/flows/evaluation/selectEvaluationByType/2`);

//评价订单
export const evaluationOrder = (data) => post(`/flows/evaluation/evaluationOrder`, data)

//查询订单信息
export const selectOrderInfo = (orderId) => get(`/flows/forwarder/selectOrderInfo/${orderId}`)

//开票支付查询费用
export const selectInvoiceOrderFee = (orderId) => get(`/flows/forwarder/selectInvoiceOrderFee/${orderId}`)



//设置支付密码
export const setPayPassword = (data) => post(`/flows/customer/payPassword/setPayPassword`, data)

//查询发票抬头信息
export const selectInvoiceTitle = () => get(`/flows/invoice/selectInvoiceTitle`)

//查询开票列表
export const selectInvoiceList = (data) => post(`flows/invoice/selectInvoiceList`, data)

// 修改接受开票的邮箱
export const updateAcceptEmail = (email) => get(`/flows/invoice/updateAcceptEmail/${email}`)

//查询可开票的订单
export const selectInvoiceOrder = (data) => post(`flows/invoice/selectInvoiceOrder`, data)

// 查询开票详情
export const selectInvoiceDetail = (data) => post(`/flows/invoice/selectInvoiceDetail`, data)

//货主运输合同生成-1.0.8
export const forwarderContractCreate = () => get(`/flows/customer/contact/forwarderContractCreate`)

//货主运输合同签署-1.0.8
export const forwarderContractSign = () => get(`/flows/customer/contact/forwarderContractSign`)

//查询用户合同列表-1.0.8
export const selectContractList = (data) => post(`/flows/customer/contact/selectContractList`, data)

//查询运输合同附件-1.0.8
export const selectContractAccessoryList = (data) => post(`/flows/customer/contact/selectContractAccessoryList`, data)


//查询结算单详情
export const selectSettlementInfo = (settlementId) => get(`/flows/customer/contact/selectSettlementInfo/${settlementId}`)

//上传头像
export const uploadAvatar = (data) => post('/flows/customer/uploadAvatar', data, { 'Content-Type': 'multipart/form-data' });

//判断用户身份类型
export const checkUserType = (phoneNumber) => get(`/flows/api/checkUserType/${phoneNumber}`);

//判断用户账号注销情况-1.1.0
export const checkUserCancelStatus = (phoneNumber) => get(`/flows/api/checkUserCancelStatus/${phoneNumber}`);

//查找货物类型-1.2
export const selectGoodsType = (goodsName) => get(`flows/forwarder/selectGoodsType/${goodsName}`);

// 查询提现明细
export const selectabcCompanyWithdrawList = (abcId) => get(`/flows/account/selectCompanyWithdrawList/${abcId}`);

// 货主查询消费/退款/收入记录
export const selectabcCompanyConsumptionList = (data) => post(`/flows/account/selectCompanyConsumptionList`, data)

// 查询充值银行号
export const selectabcBankDictList = (data) => get(`/flows/account/selectBankDictList`)

// 查询收款账户信息
export const selectProceedAccount = () => get(`/flows/proceedAccount/selectProceedAccount`);

// 添加/修改收款账户
export const saveOrUpdate = (data) => post(`/flows/proceedAccount/saveOrUpdate`, data)

// 查询银行类型列表
export const selectBankTypeList = () => get(`/flows/proceedAccount/selectBankTypeList`);

// 根据银行ID查询开户行列表
export const selectOpenBankByBankId = (data) => post(`/flows/proceedAccount/selectOpenBankByBankId`, data)

//企业钱包 提现申请
export const abcWithdrawDeposit = (data) => post(`/flows/account/withdrawDeposit`, data)

// 删除收款账户
export const deleteProceedAccount = (id) => get(`/flows/proceedAccount/deleteProceedAccount/${id}`);

//查询对账单
export const selectForwarderStatement = (data) => post(`/flows/forwarder/selectForwarderStatement`, data)

//获取开票费率
export const selectRate = () => get(`/flows/forwarder/selectRate`);

//查询支付费用-1.0.12
export const selectPayOrderFee = (data) => post(`/flows/forwarder/selectPayOrderFee`, data)

// 查询可提现金额
export const selectWithdrawAmount = () => get(`/flows/account/selectWithdrawAmount`);

// 查询货物保障服务价格
export const selectInsurancePrice = (data) => post(`/flows/forwarder/selectInsurancePrice`, data);

//查询货物保障服务开关
export const selectCompulsoryInsurance = () => get(`/flows/forwarder/selectCompulsoryInsurance`);

//查询客服联系号码
export const selectCustomerServicePhone = () => get('/flows/api/selectCustomerServicePhone');


//查询货主分享功能开关
export const selectForwarderShareSwitch = () => get('/flows/forwarder/selectForwarderShareSwitch');

//查询用户授信信息
export const selectCreditInfo = () => get('/flows/account/selectCreditInfo');

//查询货源订单列表
export const selectOrderListByDemand = (data) => post(`/flows/forwarder/selectOrderListByDemand`, data);


//TODO

//生成图像验证码
export const generateCaptcha = () => get('/match/api/generateCaptcha');

//发送登录验证码
export const sendLoginCode = (data) => post(`/match/api/sendLoginCode`, data);

//用户登录
export const login = (data) => post(`/match/api/app/login`, data);

//设置用户类型
export const settingCustomerType = (type) => get(`/match/customer/settingCustomerType/${type}`);

//查询客服电话
export const selectCustomerServiceNumber = () => get(`/match/customerServiceNumber/selectCustomerServiceNumber/2`);

//查询用户认证信息
export const selectCustomerAuth = () => get(`/match/customer/selectCustomerAuth`);

//退出登陆
export const logout = () => post(`/match/customer/logout`, {});

//查询代办
export const selectAgendaList = (data) => post(`/match/agenda/selectAgendaList`, data);

//完成待办
export const accomplishAgenda = (agendaId) => get(`/match/agenda/accomplishAgenda/${agendaId}`);

// 接受他人变更车辆
export const acceptChangeDriver = (data) => post(`/match/orderChange/acceptChangeDriver`, data);

//托运人-承运人-同意取消订单
export const agreeCancelOrder = (data) => post(`/match/order/agreeCancelOrder`, data);

//判断用户是否设置登录密码-1.0.4
export const checkHasPassword = () => get(`/match/customer/checkHasPassword`);

//设置登录密码
export const setPassword = (password) => post(`/match/customer/setPassword/${password}`, {});

//修改密码
export const updatePassword = (data) => post(`/match/customer/updatePassword`, data);

//发送修改登录密码验证码-1.0.4
export const sendUpdatePasswordCode = (data) => post(`/match/customer/sendUpdatePasswordCode`, data);

//账户注销
export const cancelCustomer = (cause) => post(`/match/customer/cancelCustomer/${cause}`, {});

//查询发票抬头列表
export const invoiceTitleList = () => get(`/match/invoiceTitle/list`);

//删除发票抬头
export const invoiceTitleDelete = (invoiceId) => get(`/match/invoiceTitle/delete/${invoiceId}`);

//新增-修改发票抬头
export const saveOrUpdateInvoiceTitle = (data) => post(`/match/invoiceTitle/saveOrUpdate`, data);

//查询合同列表
export const contractList = (data) => post(`/match/contract/list`, data);


//根据用户ID查询身份认证信息
export const selectIdentityByUserId = () => get('/match/identity/selectIdentityByUserId');

//保存身份证/人像
export const identitySave = (data) => post('/match/identity/save', data)

//上传身份证/人像
export const uploadIdentity = (data) => post('/match/identity/uploadIdentity', data, { 'Content-Type': 'multipart/form-data' });

//根据用户ID查询企业认证信息
export const selectCompanyCertificationByUserId = () => get('/match/companyCertification/selectCompanyCertificationByUserId');

//保存/修改企业认证信息-1.0.2
export const saveOrUpdateCompanyCertification = (data) => post('/match/companyCertification/saveOrUpdateCompanyCertification', data)

//上传企业营业执照-1.0.2
export const uploadCompanyCertification = (data) => post('/match/companyCertification/uploadCompanyCertification', data, { 'Content-Type': 'multipart/form-data' });

//查询钱包余额
export const checkBalance = () => get('/match/web/home/checkBalance');

//数据统计
export const selectDataStatistics = () => get('/match/web/home/selectDataStatistics');

//历史数据查询
export const historicalDataQuery = (data) => post('/match/web/home/historicalDataQuery', data)

//查询充值对公银行
export const selectBankList = (data) => post('/match/web/home/selectBankList', data)

//对账单查询
export const statementQuery = (data) => post('/match/web/home/statementQuery', data)

// 导出对账单
export const exportStatement = (data) => post(`/match/web/home/exportStatement`, data, {
    responseType: "blob",
})

//查询对账单详情
export const selectForwarderStatementInfo = (orderId) => get(`/match/statistics/selectForwarderStatementInfo/${orderId}`);

//货源模板下载
export const downloadDemandTemplate = (data) => post(`/match/web/demand/downloadDemandTemplate`, data, {
    responseType: "blob",
}
)
//导入货源
export const importDemand = (data) => post('/match/web/demand/importDemand', data, { 'Content-Type': 'multipart/form-data' });

//查询货源列表
export const selectDemandList = (data) => post('/match/web/demand/selectDemandList', data)

//托运人-查询货源是否有关联运单正在运输
export const selectDemandIsHaveTransport = (demandId) => get(`/match/demand/selectDemandIsHaveTransport`, { demandId });

//托运人-下架货源
export const removeDemand = (demandId) => get(`/match/demand/removeDemand`, { demandId });

//查询历史货源列表
export const selectDemandHistoryList = (data) => post('/match/web/demand/selectDemandHistoryList', data)

//查询订单列表
export const webOrderList = (data) => post('/match/web/order/selectOrderList', data)

//托运人-承运人-申请取消订单
export const applyForCancelOrder = (orderId) => get(`/match/order/applyForCancelOrder/${orderId}`);

//查询订单需要签署合同类型
export const selectContractType = (orderId) => get(`/match/contract/selectContractType/${orderId}`);

//生成订单撮合合同
export const generate = (orderId) => post(`/match/contract/generate/${orderId}`, {})

//生成长期协议合同
export const longTimeContract = (orderId) => post(`/match/contract/generate/longTimeContract/${orderId}`, {})

//签署订单撮合合同
export const contractSign = (contractId) => post(`/match/contract/sign/${contractId}`, {})

//签署长期协议合同
export const signLongTimeContract = (data) => post(`/match/contract/sign/longTimeContract`, data)

//申请开票
export const applyInvoice = (data) => post(`/match/invoice/applyInvoice`, data)

//托运人-承运人-查询订单详情
export const selectOrderDetail = (orderId) => get(`/match/order/selectOrderDetail/${orderId}`);

//查询常用评价
export const selectCommonAppraise = (data) => post(`/match/customerEvaluation/selectCommonAppraise`, data)

//新增评价
export const saveCustomerEvaluation = (data) => post(`/match/customerEvaluation/saveCustomerEvaluation`, data)

//查询合同文件内容
export const contractFileInfo = (contractId) => get(`/match/contract/fileInfo/${contractId}`);

//查询个人简介
export const selectBiography = (data) => post(`/match/customer/selectBiography`, data)

//托运人-货源加价
export const addDemandPrice = (data) => post(`/match/demand/addDemandPrice`, data)

//查询温度
export const queryTemperatureName = () => get(`/match/demand/queryTemperatureName`, { "temperatureName": "" });

//查询包装方式
export const queryPackageTypeName = () => get(`/match/demand/queryPackageTypeName`, { "packageTypeName": "" });

//查询车型
export const queryCarTypeName = () => get(`/match/demand/queryCarTypeName`, { "carTypeName": "" });

//查询车长
export const queryCarLengthName = () => get(`/match/demand/queryCarLengthName`, { "carLengthName": "" });

// 查询排放标准
export const queryCarDisplacement = () => get(`/match/demand/queryCarDisplacement`, { "carDisplacementName": "" });

// 查询货物类型
export const queryGoodsName = (goodsName = "") => get(`/match/demand/queryGoodsName`, { goodsName });

//托运人-发布货源
export const sendDemand = (data) => post(`/match/demand/sendDemand`, data)

//托运人-上传货源图片
export const uploadDemandGoodsPic = (data) => post('/match/demand/uploadDemandGoodsPic', data, { 'Content-Type': 'multipart/form-data' });

//查询发票抬头
export const queryInvoiceTitle = () => get(`/match/demand/queryInvoiceTitle`);

//根据发货需求ID查询发货需求信息
export const selectDemandDetail = (demandId) => get(`/match/demand/selectDemandDetail/${demandId}`);

//托运人-修改货源
export const updateDemand = (data) => post(`/match/demand/updateDemand`, data)

//查询可发起的订单
export const selectOpenInvoiceOrderList = (data) => post(`/match/web/invoice/selectOpenInvoiceOrderList`, data)

//计算订单二次确认信息
export const calculateOrderInfo = (data) => post(`/match/invoice/calculateOrderInfo`, data)

//查询发票申请管理列表
export const selectApplyList = (data) => post(`/match/web/invoice/selectApplyList`, data)

//查询发票详情
export const invoiceDetail = (invoiceId) => get(`/match/web/invoice/detail/${invoiceId}`);

//取消申请
export const cancelApply = (invoiceId) => post(`/match/invoice/cancelApply/${invoiceId}`, {});

//托运人-确认线下开票
export const confirmOfflineInvoice = (data) => post(`/match/invoice/confirmOfflineInvoice`, data);

//托运人-拒绝线下开票
export const refuseOfflineInvoice = (data) => post(`/match/invoice/refuseOfflineInvoice`, data);


//查询可开服务费发票相关信息订单
export const selectWebServiceFeeInvoiceList = (data) => post(`/match/web/serviceFeeInvoiceRecord/selectWebServiceFeeInvoiceList`, data);

//查询服务费开票记录
export const selectWebServiceFeeInvoiceRecord = (data) => post(`/match/web/serviceFeeInvoiceRecord/selectWebServiceFeeInvoiceRecord`, data);

//查询服务费开票申请详情
export const selectWebServiceFeeInvoiceRecordInfo = (data) => post(`/match/web/serviceFeeInvoiceRecord/selectWebServiceFeeInvoiceRecordInfo
`, data);

//申请服务费开票
export const recordServiceFeeInvoice = (data) => post(`/match/serviceFeeInvoiceRecord/recordServiceFeeInvoice`, data);

//查询发票抬头
export const selectOne = () => get(`/match/invoiceTitle/selectOne`);

//校验邀请码
export const validateInvitationCode = (invitationCode) => get(`/match/invitationCode/validateInvitationCode/${invitationCode}`);

//托运人-判断货源是否可以分享
export const selectDemandIsCanShare = (demandId) => get(`/match/demand/selectDemandIsCanShare/${demandId}`);

//获取行政代码
export const selectAdDivisionList = (data) => post(`/match/adDivision/selectAdDivisionList`, data);

//查询ca是否认证通过
export const caIsAgree = () => get(`/match/identity/caIsAgree`);

//web端-获取ca协议
export const webCaApply = (path) => get(`/match/identity/webCaApply`, { path });

//ca回调
export const caNotify = (params) => get(`/match/identity/caNotify`, params);

//发送短信验证码
export const sendSMS = () => get(`/match/identity/sendSMS`);

//获取经办人授权书模板
export const downloadAuthorization = () => post(`/match/companyCertification/downloadAuthorization`, {});

//上传经办人授权书
export const uploadAuthorization = (data) => post('/match/companyCertification/uploadAuthorization', data, { 'Content-Type': 'multipart/form-data' });

//查询可开票的月度支付记录
export const selectOpenInvoiceList = (data) => post(`/match/monthSettleRecord/selectOpenInvoiceList`, data);

//申请开票
export const monthSettleRecordApplyInvoice = (data) => post(`/match/monthSettleRecord/applyInvoice`, data)

//查询开票记录
export const monthSelectInvoiceList = (data) => post(`/match/monthSettleRecord/selectInvoiceList`, data)

//查询开票记录详情
export const monthSelectInvoiceDetail = (data) => post(`/match/monthSettleRecord/selectInvoiceDetail`, data)







